import { useLoyaltyProgramActivated } from '@/domains/loyalty/modules/LoyaltyProgram/hooks/useLoyaltyProgramActivated.default';

export const useShouldDisplayWallet = () => {
  const { isLoyaltyProgramV1Enabled, isOptInLoyaltyProgramV2 } =
    useLoyaltyProgramActivated();

  return isLoyaltyProgramV1Enabled || isOptInLoyaltyProgramV2;
};
